import AgentGroups from "./AgentGroups/AgentGroups";
import AgentPolicies from "./AgentPolicies/AgentPolicies";
import MailGateway from "./MailGateway";

const ProductsBody = ({ selectedProduct, selectedHost, selectedSub }) => {
  if (!selectedHost)
    return <p className="products-no-select">Please select a product and a host.</p>;

  if (selectedProduct === "Mail Gateway") {
    return <MailGateway selectedProduct={selectedProduct} selectedHost={selectedHost} />;
  } else if (selectedProduct === "Threat Hunter") {
    if (selectedSub === "Groups") {
      return <AgentGroups selectedHost={selectedHost} />;
    } else if (selectedSub === "Policies") {
      return <AgentPolicies selectedHost={selectedHost} />;
    }
  }
};

export default ProductsBody;
